import { Link } from 'react-router-dom';
import { useState } from 'react';
import CookiePreferencesModal from './CookiePreferencesModal';

export default function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCookieClick = () => {
    console.log('[Footer] Click en Configurar cookies');
    setIsModalOpen(true);
  };

  return (
    <>
      <footer className="bg-white py-12 px-8 md:px-12 lg:px-[8%]">
        <div className="border-t border-[#E8DED2] pt-10">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-8">
            <Link
              to="/"
              className="text-[24px] font-bold text-[#222222] tracking-[-0.01em] hover:opacity-80 transition-opacity cursor-pointer"
            >
              LunaFinds<span className="text-[#EBCFD4]">.</span>
            </Link>

            <div className="flex items-center gap-4">
              <a
                href="https://www.tiktok.com/@lunafinds.es"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F5F0EB] text-[#222222] hover:bg-[#EBCFD4] transition-colors cursor-pointer"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-line text-[16px]"></i>
              </a>
              <a
                href="https://www.instagram.com/lunafinds.es"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F5F0EB] text-[#222222] hover:bg-[#EBCFD4] transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-[16px]"></i>
              </a>
            </div>

            <div className="flex flex-wrap gap-6 text-[13px] text-[#6B6860]">
              <Link to="/aviso-legal" className="hover:text-[#222222] transition-colors cursor-pointer whitespace-nowrap">
                Aviso Legal
              </Link>
              <Link to="/politica-de-privacidad" className="hover:text-[#222222] transition-colors cursor-pointer whitespace-nowrap">
                Política de Privacidad
              </Link>
              <Link to="/politica-de-cookies" className="hover:text-[#222222] transition-colors cursor-pointer whitespace-nowrap">
                Política de Cookies
              </Link>
              <Link to="/aviso-de-afiliacion" className="hover:text-[#222222] transition-colors cursor-pointer whitespace-nowrap">
                Aviso de Afiliación
              </Link>
              <button
                type="button"
                onClick={handleCookieClick}
                className="hover:text-[#222222] transition-colors cursor-pointer whitespace-nowrap bg-transparent border-0 p-0 font-inherit text-[13px] text-[#6B6860] relative z-[100]"
              >
                Configurar cookies
              </button>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-[13px] text-[#A39B92]">
            <p>© 2025 LunaFinds. Hecho con 🤍 desde España.</p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#222222] transition-colors cursor-pointer whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>

      <CookiePreferencesModal 
        isOpen={isModalOpen} 
        onClose={() => {
          console.log('[Footer] Cerrando modal');
          setIsModalOpen(false);
        }} 
      />
    </>
  );
}
